import {
  ListItem,
  ListItemText,
  ListItemTextProps,
  SxProps,
} from '@mui/material';
import { Theme } from '@mui/material/styles';
import * as React from 'react';

import { mergeSxProps } from '~/utils/helpers/sxProps';

import { useSxStyles } from './useStyles';

interface CustomSxStyles {
  listItemRoot: SxProps<Theme>;
  listItemTextMultiline: SxProps<Theme>;
  primaryText: SxProps<Theme>;
}

export interface InfoListItemProps {
  primaryText: string;
  secondaryText: string;
  slotProps?: ListItemTextProps['slotProps'];
  dataCy?: string;
  customSxStyles?: Partial<CustomSxStyles>;
}

export const InfoListItem: React.FC<InfoListItemProps> = (props) => {
  const { primaryText, secondaryText, slotProps, dataCy, customSxStyles } =
    props;

  const baseStyles = useSxStyles();

  const sxStyles: CustomSxStyles = {
    listItemRoot: mergeSxProps(
      baseStyles.listItemRoot,
      customSxStyles?.listItemRoot,
    ),
    listItemTextMultiline: mergeSxProps(
      baseStyles.listItemTextMultiline,
      customSxStyles?.listItemTextMultiline,
    ),
    primaryText: mergeSxProps(
      baseStyles.primaryText,
      customSxStyles?.primaryText,
    ),
  };

  return (
    <ListItem disableGutters={true} sx={sxStyles.listItemRoot} data-cy={dataCy}>
      <ListItemText
        primary={primaryText}
        secondary={secondaryText}
        slotProps={{
          ...slotProps,
          primary: {
            variant: 'caption',
            color: 'textSecondary',
            ...slotProps?.primary,
          },
          secondary: {
            variant: 'body2',
            color: 'textPrimary',
            component: 'span',
            ...slotProps?.secondary,
          },
        }}
        sx={mergeSxProps(sxStyles.listItemTextMultiline, sxStyles.primaryText)}
      />
    </ListItem>
  );
};
